import { render, staticRenderFns } from "./historyList.vue?vue&type=template&id=7594a464&scoped=true&"
import script from "./historyList.vue?vue&type=script&lang=js&"
export * from "./historyList.vue?vue&type=script&lang=js&"
import style0 from "./historyList.vue?vue&type=style&index=0&id=7594a464&lang=scss&scoped=true&"
import style1 from "./historyList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7594a464",
  null
  
)

export default component.exports